import {combineReducers} from "redux";
import {routerReducer} from "react-router-redux";
import commonReducer from "./Common";
import Settings from "./Settings";
import authReducer from "./Auth";
import rulesReducer from "./Rules";
import tierReducer from "./Tier";
import programReducer from "./Program";
import productReducer from "./Product";
import promotionReducer from "./Promotion";
import memberReducer from "./Member";
import merchantReducer from "./Merchant";
import reportReducer from "./Report";
import dashboardReducer from "./Dashboard";
import billingReducer from "./Billing";
import rolesReducer from "./Roles";
import userReducer from "./User";
import blastReducer from "./Blast";
import pointReducer from "./Point";
import advertisingReducer from "./Advertising";
import menuReducer from "./Menu";
import doorprizeReducer from "./Doorprize";
import depositReducer from "./Deposit";
import gamificationReducer from "./Gamification";
import approvalReducer from "./Approval";
import receiptApprovalReducer from "./ReceiptApproval";
import reconciliationReducer from "./Reconciliation";
import storeReducer from "./Store";
import auditTrailReducer from "./AuditTrail";
import validationVoucherReducer from "./ValidationVoucher";
import inqPostAddPointReducer from "./AddPoint";
import builderReducer from "./Builder";

import membersOverviewReducer from "./NewDashboard/MembersOverview";
import PointsOverview from "./NewDashboard/PointsOverview";
import RedemtionssOverview from "./NewDashboard/RedemtionsOverview";

import { SIGNOUT_USER_SUCCESS, BACK_TO_LOGIN } from "../../constants/ActionTypes";

const appReducer = combineReducers({
    routing: routerReducer,
    settings: Settings,
    auth : authReducer,
    rules : rulesReducer,
    tierState : tierReducer,
    commonState : commonReducer,
    programState : programReducer,
    productState : productReducer,
    promotionState : promotionReducer,
    memberState : memberReducer,
    merchantState : merchantReducer,
    reportState : reportReducer,
    dashboardState : dashboardReducer,
    billingState : billingReducer,
    rolesState : rolesReducer,
    userState : userReducer,
    blastState : blastReducer,
    advertisingState : advertisingReducer,
    menuState : menuReducer,
    doorprizeState : doorprizeReducer,
    pointState : pointReducer,
    depositState: depositReducer,
    gamificationState: gamificationReducer,
    approvalState : approvalReducer,
    receiptApprovalState : receiptApprovalReducer,
    reconciliationState : reconciliationReducer,
    storeState : storeReducer,
    auditTrailState : auditTrailReducer,
    validationVoucherState : validationVoucherReducer,
    addPointState : inqPostAddPointReducer,
    builderState : builderReducer,
    membersOverview: membersOverviewReducer,
    PointsOverview: PointsOverview,
    RedemtionssOverview: RedemtionssOverview,
});

const rootReducer = (state, action) => {
    if (action.type === SIGNOUT_USER_SUCCESS || action.type === BACK_TO_LOGIN) {
        const { settings, routing, auth } = state || {};
        state = { settings, routing, auth };
    }
    return appReducer(state, action);
};

export default rootReducer;
